import { StandardEvents } from '@shopify/events';

document.addEventListener(
  StandardEvents.productSelect,
  async (event) => {
    try {
      const { detail } = (await event.promise) || {};
      if (!detail?.html) return;
      for (const el of document.querySelectorAll('[data-mit-variante]')) {
        const neu = detail.html.querySelector(`[data-mit-variante="${el.dataset.mitVariante}"]`);
        if (neu) el.innerHTML = neu.innerHTML;
      }
    } catch (_) {
    }
  },
  true
);
